'use client'

import { useTranslate } from '@tolgee/react'
import ResponsiveSection from '@/components/common/ResponsiveSection'
import { H1 } from '@/components/common/Typo'
import { Card } from 'oddle-shop-monorepo.design-system'
import ExternalContent from '@/components/common/ExternalContent'
import { useGetTermsAndConditionsQuery } from '@/services/oms'
import { useSelector } from 'react-redux'
import { selectDetailMenuSite } from '@/redux/meta'

function TermsAndConditions() {
  const { t } = useTranslate()
  const menuMeta = useSelector(selectDetailMenuSite)
  const { data: termsAndConditions } = useGetTermsAndConditionsQuery(
    menuMeta?.menu?.id,
    {
      skip: !menuMeta?.menu?.id,
    }
  )

  return (
    <ResponsiveSection>
      <ResponsiveSection.Container>
        <H1 className="mb-5" sectionHeading>
          {t('Terms and Conditions')}
        </H1>

        {termsAndConditions?.data ? (
          <Card className="p-6">
            <ExternalContent>
              <div
                className="text-body [&>ol]:my-4 [&>ol]:ml-[40px] [&>ol]:block [&>ol]:list-disc [&>p]:my-4 [&>ul]:my-4 [&>ul]:ml-[40px] [&>ul]:block [&>ul]:list-decimal"
                dangerouslySetInnerHTML={{
                  __html: termsAndConditions.data,
                }}
              />
            </ExternalContent>
          </Card>
        ) : null}
      </ResponsiveSection.Container>
    </ResponsiveSection>
  )
}

export default TermsAndConditions
